import { render, staticRenderFns } from "./ServicesReservationsNewPayment.vue?vue&type=template&id=508b55c4&scoped=true&"
import script from "./ServicesReservationsNewPayment.vue?vue&type=script&lang=js&"
export * from "./ServicesReservationsNewPayment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "508b55c4",
  null
  
)

export default component.exports